export class B2B {
    id;
    title;
    constructor({ id, title }) {
        this.id = id;
        this.title = title;
    }
}
